import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Detalhes do contrato',
  tabs: {
    [info_tab]: 'Informação',
    [contract_tab]: 'Contrato',
    [versioning_tab]: 'Versões',
  },
  sections: {
    price_info: 'Informação de preço',
    contact: 'Contrato atual',
    signature_history: 'Histórico de assinaturas',
  },
  labels: {
    not_signed: 'O contrato ainda não foi assinado',
  },
  modals: {
    preview_contract: {
      title: 'Pré-visualizar contrato',
    },
    switch_to_annual: {
      title: 'Mudar para anual',
    },
  },
  buttons: {
    save: 'Guardar',
    preview_and_sign: 'Pré-visualizar e assinar',
    download: 'Descarregar',
    switch_to_annual: 'Mudar para anual',
  },
  toasts: {
    failed_to_load_data: 'Erro ao carregar dados',
    failed_to_save_changes: 'Erro ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
